__turbopack_context__.v({
  "ActiveFiltersCount": "UVPpzW_ActiveFiltersCount",
  "Container": "UVPpzW_Container",
  "Disabled": "UVPpzW_Disabled",
  "Label": "UVPpzW_Label",
  "MainCategory": "UVPpzW_MainCategory",
  "Option": "UVPpzW_Option",
  "Options": "UVPpzW_Options",
  "Root": "UVPpzW_Root",
  "Trigger": "UVPpzW_Trigger",
});
